/** User level constants */
export enum USER_LEVEL {
	MATCHED = 'MATCHED',
	UNMATCHED = 'UNMATCHED',
	CLIENT_BIOMETRIC_ELIGIBLE = 'CLIENT_BIOMETRIC_ELIGIBLE',
	CLIENT_BIOMETRIC_NOT_ELIGIBLE = 'CLIENT_BIOMETRIC_NOT_ELIGIBLE',
	CLIENT_HIDE_HM = 'CLIENT_HIDE_HM',
}
